import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import appcache from "../../../services/appcache";
import usernameService from "../../../services/username.service";
import ProfileHeader from "./ProfileHeader";
import Footer from "../Footer";
import LoadingProgressBar from "../../../components/loading-progressbar/loadingprogressbar";

const ProfileDetails = () => {

    const [loading, setLoading] = useState(false);
    const [profileDetails, setProfileDetails] = useState([]);

    useEffect(() => {
        const CurrentLoggedInUser = appcache.GetCurrentLoggedInUser();

        if (CurrentLoggedInUser && CurrentLoggedInUser.Token) {
            const fetchProfile = async () => {
                setLoading(true);
                try {
                    const userNameServiceInstance = await usernameService;
                    const response = await userNameServiceInstance.GetUserProfile();

                    if (response.status === 200) {
                        setProfileDetails(response.data);
                         //  console.log("profile", response?.data);
                    } else {
                         //  console.log("Error while fetching user data. Status:", response.status);
                         //  console.log("Error Message:", response.data);
                    }
                } catch (error) {
                    console.error("Error fetching user profile:", error);
                } finally {
                    setLoading(false);
                }
            };

            fetchProfile();
        } else {
             //  console.log("Token not available");
        }
    }, []);


    return (
        <>
            <Helmet>
                <title> User Profile | ProClaimz </title>
            </Helmet>
            
                <Card sx={{
                    padding: '2px',
                    boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)',
                    borderRadius: '10px', // Add rounded corners
                    margin: '5px 3px 5px 3px',
                    height: '100%',
                    boxSizing: 'border-box',
                    display: 'flex',
                    flexDirection: 'column',
                    flexGrow: 1,

                }}>
                    <CardContent style={{
                        flexGrow: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        boxSizing: 'border-box',
                        paddingBottom: '0.5rem',
                        minHeight: 0
                    }}>
                        <ProfileHeader />
                    <Box sx={{ marginTop: "1rem" }}>
                        {profileDetails.length > 0 &&
                            profileDetails.map((profile, index) => (
                                <Grid container spacing={2} key={index}> { /* NOSONAR */ }
                                    {Object.entries(profile).map(([key, value]) => (
                                        <Grid item xs={12} sm={6} key={key}>
                                            <Typography variant="body1" fontWeight="bold" component="span" fontSize="14px">
                                                {key}:
                                            </Typography>{" "}
                                            <Typography variant="body1" component="span" fontSize="13px">
                                                {value}
                                            </Typography>
                                        </Grid>
                                    ))}
                                </Grid>
                            ))}
                    </Box>
                                 
                    {loading && <LoadingProgressBar />}  
                    </CardContent>
                </ Card>
     
            <Footer />
        </>    
    )
};

export default ProfileDetails;